module.exports = __webpack_public_path__ + "assets/sushi_mobile-6002de.svg";